export var InputCloneMode = /* @__PURE__ */ ((InputCloneMode2) => {
  InputCloneMode2["ALWAYS"] = "always";
  InputCloneMode2["NEVER"] = "never";
  InputCloneMode2["FROM_NODE"] = "from_node";
  return InputCloneMode2;
})(InputCloneMode || {});
